import './search-modal.scss';

/**
 * version    1.0
 * class      SearchModal
 * classdesc  SearchModal
 */
export class SearchModal {}
